(function () {
	angular
		.module('trackeye')
		.factory('UserService', UserService);

	UserService.$inject = ['ConfigurationService', 'C4ApiService', '$q'];

	function UserService(ConfigurationService, api, $q) {
		var exports = {};

		exports.getUserConfiguration = function () {
			return ConfigurationService.findOneByName('te-account');
		};

		exports.getAccount = function () {
			return api.account().get();
		};

		exports.getTransactions = function () {
			return api.account().transactions();
		};

		exports.createAccount = function (data) {
			return api.create_account({
				"email": data.email,
				"username": data.username,
				"name": data.name,
				"password": data.password,
				"number": data.device_number,
				"code": data.device_code
			});
		};

		exports.migrateAccount = api.migrateAccount;

		exports.requestReset = function (email) {
			return api.local('post', 'reset/password', {email: email});
		};

		exports.recoverPassword = function (password) {
			var account = api.account(),
				deferred = $q.defer();

			account.get(function (acc) {
				acc.password = password;
				acc.$update().then(deferred.resolve, deferred.reject);
			});

			return deferred.promise;
		};

		exports.updateAccount = function (data) {
			return api.account().update(data);
		};

		return exports;
	}
})();